import { copyArr } from "core/iterable_utils";

import CompanyDetails from "./CompanyDetails/CompanyDetails";
import { JustificationsDetails } from "./JustificationsDetails/JustificationsDetails";

export const OffersDetailEnum = {
	COMPANY: "company",
	JUSTIFICATIONS: "justifications",
};

export const changeShowDetails = ({ tableData, editingRowKey, offersDetailValue }) => {
	const newTableData = copyArr(tableData);

	return newTableData.map((row) => {
		if (row.key === editingRowKey) {
			if (row.show_details === offersDetailValue) {
				row.show_details = "";
			} else {
				row.show_details = offersDetailValue;
			}
		}
		return row;
	});
};

export const SomItemOffersDetails = ({ rowObj, options, funcs }) => {
	switch (rowObj.show_details) {
		case OffersDetailEnum.COMPANY:
			return <CompanyDetails rowObj={rowObj} options={options} funcs={funcs} />;
		case OffersDetailEnum.JUSTIFICATIONS:
			return <JustificationsDetails rowObj={rowObj} options={options} funcs={funcs} />;
		default:
			<></>;
	}
};
